import { API } from 'utils/api/api'
import { formatRequestString } from 'utils/helpers/api/queryString'
import { ScanHistory, GetScanSummaryParams } from '@ketch-com/windlass/dist/dataSentry/v1/scans/scan'

export const fetchScanHistory = ({ 'property-codes': propertyCode }: GetScanSummaryParams) =>
  API.get<ScanHistory>(
    formatRequestString({
      entityUrl: `/api/v1/data-sentry/scans/history`,
      params: {
        filters: {
          ...(propertyCode
            ? {
                'property-codes': propertyCode,
              }
            : {}),
        },
      },
    }),
  )
